/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Next_Run_In_OneInputs */



/**
* | output |
* | --- |
* | "next run in 1 day" |
*
* @param {Partner_Billing_Board_Next_Run_In_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_next_run_in_one = /** @type {((inputs?: Partner_Billing_Board_Next_Run_In_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Next_Run_In_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("nächster Lauf in 1 Tag")
	return /** @type {LocalizedString} */ ("next run in 1 day")
});